<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useTranslation } from '@/composables/useTranslation'
  import ActionCompleted from '@/components/svg/Illustrations/ActionCompleted.vue'

  const { t } = useTranslation({
    en: {
      great: 'Great!',
      document: 'Document',
      documentCompleted: 'This document has been completed and sent.',
      pdfCompleted: 'has been completed and sent.'
    },
    de: {
      great: 'Super!',
      document: 'Dokument',
      documentCompleted: 'Dieses Dokument wurde nun ausgefüllt und versendet.',
      pdfCompleted: 'wurde nun ausgefüllt und versendet.'
    }
  })

  const route = useRoute()

  const isPdfDocument = computed(() => {
    const t = Array.isArray(route.query.document_type)
      ? route.query.document_type[0]
      : route.query.document_type
    return String(t || '').toLowerCase() === 'pdf'
  })

  const documentTitle = computed(() => {
    const titleParam = Array.isArray(route.query.document_title)
      ? route.query.document_title[0]
      : route.query.document_title
    return titleParam || t('document')
  })

  const title = computed(() => {
    return t('great')
  })

  const message = computed(() => {
    return isPdfDocument.value
      ? `${documentTitle.value} ${t('pdfCompleted')}`
      : t('documentCompleted')
  })
</script>

<template>
  <main class="flex h-screen min-h-screen w-screen items-center justify-center bg-gray-50">
    <div
      class="container mx-auto flex flex-col items-center justify-center p-5 text-gray-700 md:flex-row"
      role="status"
      aria-live="polite"
    >
      <div class="max-w-md text-center md:text-left">
        <h1
          tabindex="-1"
          class="text-lg font-bold md:text-4xl"
        >
          {{ title }}
        </h1>
        <p class="font-semi-bold mt-6 text-xl leading-normal md:text-3xl">
          {{ message }}
        </p>
      </div>
      <div
        class="mt-10 max-w-lg md:mt-0"
        aria-hidden="true"
      >
        <ActionCompleted class="text-purple-600" />
      </div>
    </div>
  </main>
</template>
